import Typography from '../../Typography';
import Box from 'component/layoutComponents/Box';
import React, { memo } from 'react';
import { TextGray } from '../ProductDetail.styles';

const DescriptionContent = ({ description, title }: { description: string; title: string; }) => {
  return (
    <>
      <Typography variant="h6" >{title}</Typography>
      <Box paddingTop="8px">
        <TextGray variant='body1' color="text.secondary" lineHeight="1.5" letterSpacing="0.15px">{description}</TextGray>
      </Box>
    </>
  );
};

export default memo(DescriptionContent);
